// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vec-option-group__OptionGroup-module--k2K85.ant-radio-group {
    display: flex !important;
    flex-direction: column !important;
    gap: var(--space-sm) !important;
    width: 100%;
}

.vec-option-group-fit__OptionGroup-module--LSf5Q[data-scrolls].ant-radio-group {
    overflow-x: auto;
    padding: 3px;
    margin: -3px;
    width: calc(100% + 6px);
}

.vec-option-group-fit__OptionGroup-module--LSf5Q[data-scrolls] > .ant-radio-button-wrapper {
    width: calc(100% + var(--vec-fit-extra)) !important;
    flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./vector/src/Option/OptionGroup.module.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,mDAAmD;IACnD,cAAc;AAClB","sourcesContent":[".vec-option-group:global(.ant-radio-group) {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: var(--space-sm) !important;\n    width: 100%;\n}\n\n.vec-option-group-fit[data-scrolls]:global(.ant-radio-group) {\n    overflow-x: auto;\n    padding: 3px;\n    margin: -3px;\n    width: calc(100% + 6px);\n}\n\n.vec-option-group-fit[data-scrolls] > :global(.ant-radio-button-wrapper) {\n    width: calc(100% + var(--vec-fit-extra)) !important;\n    flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vecOptionGroup": `vec-option-group__OptionGroup-module--k2K85`,
	"vecOptionGroupFit": `vec-option-group-fit__OptionGroup-module--LSf5Q`
};
export default ___CSS_LOADER_EXPORT___;
